import { createContext, useContext } from "react"

const TrustCenterContext = createContext(null)

export function TrustCenterProvider({ value, children }) {
    return (
        <TrustCenterContext.Provider value={value}>
            {children}
        </TrustCenterContext.Provider>
    )
}

export function useTC() {
    const ctx = useContext(TrustCenterContext)
    if (!ctx) throw new Error("useTC must be used within TrustCenterProvider")
    return ctx
}
